import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Forecast} from '../forecast/forecast';
import {map} from 'rxjs/operators';
import * as classTransformer from 'class-transformer';
import {Subsidiary} from '../subsidiary/subsidiary';
import {SubsidiaryService} from '../subsidiary/subsidiary.service';
import {ForecastService} from '../forecast/forecast.service';
import {HttpClient} from '@angular/common/http';
import {ForecastDetail} from './forecast-detail';
import {ForecastDetailCollection} from './forecast-detail-collection';
import {v7 as uuidv7} from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class ForecastDetailService {

    constructor(private httpClient: HttpClient) {
    }

    public createNewForecastDetail(
        requestedQuantity: number,
        subsidiary: Subsidiary,
        forecast: Forecast
    ): Observable<ForecastDetail> {
        const params = {
            subsidiary: SubsidiaryService.buildIri(subsidiary),
            forecast: ForecastService.buildIri(forecast),
            requestedQuantity,
        };

        return this.httpClient
            .post('/forecasts/' + forecast.id + '/details', params)
            .pipe(map((forecastDetailData: any) => classTransformer.plainToInstance(ForecastDetail, forecastDetailData)));
    }

    public updateAllocations(forecast: Forecast, newAllocations: Record<string, number>): Observable<ForecastDetailCollection> {
        const params = Object.entries(newAllocations).map(([subsidiaryId, allocatedQuantity]) => {
            const existingDetail = forecast.forecastDetails.find(
                detail => detail.subsidiary.id === subsidiaryId
            );

            return {
                id: existingDetail ? existingDetail.id : uuidv7(),
                subsidiary: SubsidiaryService.buildIri(subsidiaryId),
                requestedQuantity: existingDetail?.requestedQuantity ?? 0,
                allocatedQuantity,
            };
        });

        return this.httpClient
            .put('/forecasts/' + forecast.id + '/details', params)
            .pipe(map((result: any) => {
                const collection = new ForecastDetailCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setForecastDetails(
                    result['member'].map((forecastDetailData: any) => classTransformer.plainToInstance(ForecastDetail, forecastDetailData))
                );

                return collection;
            }));
    }
}
